export class OfferMaster{
    public offerId:number;
public coupenCode:string;
public validityfrom:Date;
public validityTill:Date;
public discountAmount:number;
public discountPercent:number;
public inPercent:boolean;
public offerName:string;
public isDelete:string;
public pageNumber :number;
public pageSize:number;
public errormsg:string;
}